// src/pages/Settings.js
import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Settings.css';

const Settings = () => {
    const [settings, setSettings] = useState(null);
    const [plans, setPlans] = useState([]);
    const [activeTab, setActiveTab] = useState('general');
    const [editingPlan, setEditingPlan] = useState(null);

    // --- YENİ: Ödeme ayarları state'leri ---
    const [wallets, setWallets] = useState([]);
    const [newWallet, setNewWallet] = useState({
        currency: 'USDT',
        network: 'TRC20',
        wallet_address: ''
    });

    useEffect(() => {
        API.get('/settings')
            .then(res => setSettings(res.data))
            .catch(console.error);
        loadPlans();
        loadWallets();   // YENİ
    }, []);

    const loadPlans = () => {
        API.get('/manager-plans')
            .then(res => setPlans(res.data))
            .catch(console.error);
    };

    const loadWallets = () => {
        API.get('/payment-settings')
            .then(res => setWallets(res.data))
            .catch(console.error);
    };

    const handlePlanSave = async (plan) => {
        try {
            await API.put(`/manager-plans/${plan.id}`, plan);
            setEditingPlan(null);
            loadPlans();
        } catch (err) {
            alert('Failed to save plan: ' + (err.response?.data?.error || err.message));
        }
    };

    return (
        <div className="settings-page">
            <h1>⚙️ Settings</h1>

            <div className="settings-tabs">
                <button
                    className={`tab-btn ${activeTab === 'general' ? 'active' : ''}`}
                    onClick={() => setActiveTab('general')}
                >
                    General
                </button>
                <button
                    className={`tab-btn ${activeTab === 'plans' ? 'active' : ''}`}
                    onClick={() => setActiveTab('plans')}
                >
                    Manager Plans
                </button>
                {/* YENİ SEKME */}
                <button
                    className={`tab-btn ${activeTab === 'payment' ? 'active' : ''}`}
                    onClick={() => setActiveTab('payment')}
                >
                    Payment
                </button>
            </div>

            {activeTab === 'general' && settings && (
                <div className="settings-card">
                    <div className="setting-row">
                        <span className="setting-label">Application Name</span>
                        <span className="setting-value">{settings.app_name}</span>
                    </div>
                    <div className="setting-row">
                        <span className="setting-label">Version</span>
                        <span className="setting-value">{settings.version}</span>
                    </div>
                    <div className="setting-row">
                        <span className="setting-label">Admin Panel</span>
                        <span className="setting-value">{settings.admin_panel ? 'Active' : 'Inactive'}</span>
                    </div>
                    <p className="settings-note">More settings will be available soon.</p>
                </div>
            )}

            {activeTab === 'plans' && (
                <div className="plans-section">
                    {plans.map(plan => (
                        <div key={plan.id} className="plan-card">
                            {editingPlan?.id === plan.id ? (
                                <div className="plan-edit-form">
                                    <label className="input-label">Plan Name</label>
                                    <input
                                        type="text"
                                        value={editingPlan.name}
                                        onChange={e => setEditingPlan({ ...editingPlan, name: e.target.value })}
                                        placeholder="e.g., Monthly"
                                    />
                                    <label className="input-label">Description</label>
                                    <textarea
                                        value={editingPlan.description || ''}
                                        onChange={e => setEditingPlan({ ...editingPlan, description: e.target.value })}
                                        placeholder="Plan description..."
                                    />
                                    <div className="input-row">
                                        <div className="input-group">
                                            <label className="input-label">Price (USDT)</label>
                                            <input
                                                type="number"
                                                value={editingPlan.price}
                                                onChange={e => setEditingPlan({ ...editingPlan, price: e.target.value })}
                                                placeholder="50.00"
                                            />
                                        </div>
                                        <div className="input-group">
                                            <label className="input-label">Duration (Days)</label>
                                            <input
                                                type="number"
                                                value={editingPlan.duration_days}
                                                onChange={e => setEditingPlan({ ...editingPlan, duration_days: e.target.value })}
                                                placeholder="30"
                                            />
                                        </div>
                                        <div className="input-group">
                                            <label className="input-label">Stars Price</label>
                                            <input
                                                type="number"
                                                value={editingPlan.stars_price}
                                                onChange={e => setEditingPlan({ ...editingPlan, stars_price: e.target.value })}
                                                placeholder="250"
                                            />
                                        </div>
                                    </div>
                                    <div className="edit-actions">
                                        <button onClick={() => handlePlanSave(editingPlan)}>Save</button>
                                        <button onClick={() => setEditingPlan(null)}>Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="plan-info">
                                        <h3>{plan.name}</h3>
                                        <p>{plan.description}</p>
                                        <div className="plan-details">
                                            <span>💰 {plan.price} {plan.currency}</span>
                                            <span>⏳ {plan.duration_days} days</span>
                                            <span>⭐ {plan.stars_price} Stars</span>
                                        </div>
                                        <span className={`plan-status ${plan.is_active ? 'active' : 'inactive'}`}>
                                            {plan.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                    <button
                                        className="edit-btn"
                                        onClick={() => setEditingPlan({ ...plan })}
                                    >
                                        Edit
                                    </button>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* YENİ: Ödeme Ayarları Sekmesi */}
            {activeTab === 'payment' && (
                <div className="payment-settings-section">
                    <h3>Cüzdan Adresleri</h3>
                    <div className="add-wallet-form">
                        <select
                            value={newWallet.currency}
                            onChange={e => setNewWallet({ ...newWallet, currency: e.target.value })}
                        >
                            <option value="USDT">USDT</option>
                            <option value="TON">TON</option>
                        </select>
                        <select
                            value={newWallet.network}
                            onChange={e => setNewWallet({ ...newWallet, network: e.target.value })}
                        >
                            <option value="TRC20">TRC20</option>
                            <option value="BEP20">BEP20</option>
                            <option value="ERC20">ERC20</option>
                            <option value="TON">TON</option>
                        </select>
                        <input
                            type="text"
                            placeholder="Wallet address"
                            value={newWallet.wallet_address}
                            onChange={e => setNewWallet({ ...newWallet, wallet_address: e.target.value })}
                        />
                        <button
                            onClick={async () => {
                                try {
                                    await API.post('/payment-settings', newWallet);
                                    setNewWallet({ currency: 'USDT', network: 'TRC20', wallet_address: '' });
                                    loadWallets();
                                } catch (err) {
                                    alert('Error adding wallet');
                                }
                            }}
                        >
                            Add
                        </button>
                    </div>
                    <div className="wallet-list">
                        {wallets.map(w => (
                            <div key={w.id} className="wallet-item">
                                <span>{w.currency} ({w.network})</span>
                                <code>{w.wallet_address}</code>
                                <button
                                    onClick={async () => {
                                        await API.delete(`/payment-settings/${w.id}`);
                                        loadWallets();
                                    }}
                                >
                                    🗑️
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Settings;